import { render, staticRenderFns } from "./plusGoodsTabIndex1.vue?vue&type=template&id=8ed6a980"
import script from "./plusGoodsTabIndex1.vue?vue&type=script&lang=js"
export * from "./plusGoodsTabIndex1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports